import { useState } from "react";
import { INITIAL_CART_CONTEXT_STATE } from "./constants";

export const useCartShow = () => {
  const [cartIsOpen, setCartIsOpen] = useState(
    INITIAL_CART_CONTEXT_STATE.cartIsOpen
  );

  const toggleCartOpening = () => {
    setCartIsOpen((isOpen) => !isOpen);
  };

  return {
    cartIsOpen,
    toggleCartOpening
  };
};
